import React from "react";

function NewsTicker({ items }) {
  return (
    <>
      <style>
        {`
          /* Make news ticker background red, keep text white */
          .announcement-bar {
            background-color: #db1215 !important;
          }
          .announcement-bar,
          .announcement-bar .announcement-bar-item,
          .announcement-bar .announcement-bar-item p,
          .announcement-bar .box-sw-announcement-bar,
          .announcement-bar .wrap-announcement-bar {
            color: #ffffff !important;
          }
        `}
      </style>
      <div className="announcement-bar bg_dark">
        <div className="wrap-announcement-bar">
          <div className="box-sw-announcement-bar speed-1">
            {items.map((item, index) => (
              <div className="announcement-bar-item" key={index}>
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
        <span className="icon-close close-announcement-bar"></span>
      </div>
    </>
  );
}

export default NewsTicker;
